export default __webpack_public_path__ + "static/media/heat-2.378301eb.png";